import { LogOut } from 'lucide-react'

import { useLang } from '../../core/lang'
import LangKeys from '../../core/locales/keys'

function LogoutPage() {

  // =====================================================
  // LANGUAGE
  // =====================================================

  const { t } = useLang()

  // =====================================================
  // LOGOUT
  // =====================================================

  const handleLogout = () => {

    localStorage.removeItem('token')
    localStorage.removeItem('login_token')
    localStorage.removeItem('business_profile')
    localStorage.removeItem('user')

    localStorage.clear()

    window.location.href = '/login'
  }

  return (

    <div style={styles.page}>

      <div style={styles.card}>

        {/* ICON */}
        <div style={styles.iconWrap}>
          <LogOut size={34} />
        </div>

        {/* TITLE */}
        <div style={styles.title}>
          {t(LangKeys.logout)}
        </div>

        {/* SUBTITLE */}
        <div style={styles.subtitle}>
          {t(LangKeys.logout_confirm)}
        </div>

        {/* BUTTON */}
        <button
          style={styles.button}
          onClick={handleLogout}
        >
          {t(LangKeys.confirm_logout)}
        </button>

      </div>

    </div>
  )
}

const styles = {

  page: {
    minHeight: '75vh',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    padding: '20px',
  },

  card: {
    width: '100%',
    maxWidth: '420px',

    backgroundColor: '#fff',

    borderRadius: '24px',

    padding: '32px',

    border: '1px solid #E5E7EB',

    boxShadow:
      '0 14px 40px rgba(15,23,42,0.08)',

    textAlign: 'center',
  },

  iconWrap: {
    width: '76px',
    height: '76px',

    borderRadius: '50%',

    background:
      'linear-gradient(180deg,#FEE2E2,#FECACA)',

    color: '#DC2626',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    margin: '0 auto',
  },

  title: {
    marginTop: '18px',

    fontSize: '24px',

    fontWeight: '700',

    color: '#111827',
  },

  subtitle: {
    marginTop: '10px',

    fontSize: '14px',

    color: '#6B7280',

    lineHeight: '24px',
  },

  button: {
    width: '100%',

    height: '54px',

    marginTop: '24px',

    border: 'none',

    borderRadius: '16px',

    background:
      'linear-gradient(180deg,#DC2626,#B91C1C)',

    color: '#fff',

    fontSize: '15px',

    fontWeight: '700',

    cursor: 'pointer',

    boxShadow:
      '0 10px 24px rgba(220,38,38,0.25)',
  },
}

export default LogoutPage